const rankings = [
  { rank: 1, title: '斗罗大陆', tag: '热血·玄幻', heat: '🔥 980万热度', change: 'up' },
  { rank: 2, title: '完美世界', tag: '奇幻·冒险', heat: '🔥 856万热度', change: 'up' },
  { rank: 3, title: '吞噬星空', tag: '科幻·机甲', heat: '🔥 742万热度', change: 'same' },
  { rank: 4, title: '一念永恒', tag: '仙侠·搞笑', heat: '🔥 685万热度', change: 'up' },
  { rank: 5, title: '大王饶命', tag: '热血·都市', heat: '🔥 621万热度', change: 'down' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">热门排行</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">本周最受欢迎漫画热度排行榜</p>
        </div>

        <div className="max-w-[640px] mx-auto bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
          {rankings.map((item, idx) => (
            <div
              key={item.rank}
              className={`flex items-center gap-4 px-4 md:px-6 py-4 cursor-pointer hover:bg-background-50 transition-colors group ${
                idx < rankings.length - 1 ? 'border-b border-background-200' : ''
              }`}
            >
              <span className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">{item.title}</div>
                <div className="text-xs text-foreground-500">{item.tag}</div>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-xs text-foreground-600 hidden sm:inline">{item.heat}</span>
                <span className={`text-xs ${item.change === 'up' ? 'text-primary-600' : item.change === 'down' ? 'text-secondary-600' : 'text-foreground-400'}`}>
                  {item.change === 'up' && <i className="ri-arrow-up-line"></i>}
                  {item.change === 'down' && <i className="ri-arrow-down-line"></i>}
                  {item.change === 'same' && <i className="ri-arrow-right-line"></i>}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}